import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_MARKETING,
  REQUEST_CREATE_MASTER_MARKETING,
  SET_MASTER_MARKETING,
  SUCCESS_CREATE_MASTER_MARKETING,
  ERROR_GET_MASTER_MARKETING,
  ERROR_CREATE_MASTER_MARKETING,
  SUCCESS_DELETE_MASTER_MARKETING,
  SUCCESS_UPDATE_MASTER_MARKETING,
  REQUEST_DELETE_MASTER_MARKETING,
  REQUEST_UPDATE_MASTER_MARKETING,
  ERROR_DELETE_MASTER_MARKETING,
  ERROR_UPDATE_MASTER_MARKETING,
} from "./marketingActionTypes";

function* requestMasterMarketings(action: Record<string, any>): any {
  try {
    const result: any = yield call(getMarketingsMaster);
    yield put({ type: SET_MASTER_MARKETING, payload: result.data.data });
    console.warn(result.data, "jhuihihi");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_MARKETING, payload: message });
  }
}

function* requestUpdateMasterTagMarketing(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterMarketings,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_MARKETING,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_MARKETING, payload: message });
  }
}

function* requestDeleteMasterTagMarketing(action: Record<string, any>): any {
  try {
    yield call(deleteMasterMarketings, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_MARKETING,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_MARKETING, payload: message });
  }
}

function* requestCreateMasterMarketings(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterMarketings, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_MARKETING,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_MARKETING, payload: message });
  }
}

export function getMarketingsMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/marketing`,
    withCredentials: true,
  });
}

export function createMasterMarketings(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/marketing`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterMarketings(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/marketing/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterMarketings(
  payload: Record<string, any>,
  _id: string
) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/marketing/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const marketingsMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_MARKETING, requestMasterMarketings),
    takeLatest(REQUEST_CREATE_MASTER_MARKETING, requestCreateMasterMarketings),
    takeLatest(
      REQUEST_UPDATE_MASTER_MARKETING,
      requestUpdateMasterTagMarketing
    ),
    takeLatest(
      REQUEST_DELETE_MASTER_MARKETING,
      requestDeleteMasterTagMarketing
    ),
  ]);
};

export default marketingsMasterSaga;
